import { combineReducers } from "@reduxjs/toolkit";
import { RootState } from "..";
import fortuneWheelTableStore from "./fortuneWheelTableStore";
import fortuneWheelBonusStore from './Bonus/fortuneWheelBonus'
import fortuneWheelProfileStore from './Profile/fortuneWheelProfile'
import fortuneWheelEntityStore from './Database/fortuneWheelEntity'
// export selectors
export const selectFortuneWheelTable = (state: RootState) => state.fortuneWheel.tables;

export const selectFortuneWheelBonus = (state: RootState) => state.fortuneWheel.bonus;

export const selectFortuneWheelProfile = (state: RootState) => state.fortuneWheel.profile;

export const selectFortuneWheelEntity = (state: RootState) => state.fortuneWheel.entity;

export const fortuneWheelReducer = combineReducers({
  tables: fortuneWheelTableStore,
  bonus: fortuneWheelBonusStore,
  profile: fortuneWheelProfileStore,
  entity: fortuneWheelEntityStore,
});
